export function camelToNormal(str) {
  if (!str) return "";
  return str
    // insert a space before all caps
    .replace(/([A-Z])/g, " $1")
    // capitalize first letter
    .replace(/^./, (char) => char.toUpperCase())
    .trim();
}